<title>{{ paymentsPage.htmlTitle }}</title>
<app-banner [banner]="paymentsPage.banner"></app-banner>
<div class="container faq-disruption-notifications">
  <a [href]="BackLinkURL"><i [ngClass]="BackLinkIcon"></i>{{ BackLinkTitle }}</a>
  <div class="border">
    <br />
    <app-section [param]="param" [sections]="paymentsPage.sectionsTopSection"></app-section>
    <app-table-section [isPaymentsNdcCommercialFaqPage]="true" [tableSections]="paymentsPage.tableSectionTopTableSection"></app-table-section>
    <app-section [param]="param" [sections]="paymentsPage.sectionsMiddleSection"></app-section>
    <app-table-section [tableSections]="paymentsPage.tableSectionMidddleTableSection"></app-table-section>
    <app-section [param]="param" [sections]="paymentsPage.sectionsBottomSection"></app-section>
  </div>
</div>
